import { Box, Popover } from "@mui/material";
import isEmpty from "../../../common/helpers/isEmpty";
import { InvoiceAttachmentsButton } from "../styled";
import { InvoiceAttachments } from "../attachments/InvoiceAttachments";
import { useState } from "react";
import { InvoiceEdit } from "../invoiceAPI";
import { useTranslation } from "react-i18next";
import { ReactComponent as AttachmentIcon } from "../../../common/icons/attachment.svg";

type Props = {
  invoice: InvoiceEdit;
};

export const PreviewAttachments = ({ invoice }: Props) => {
  const { t } = useTranslation();

  const [attachmentAnchorEl, setAttachmentAnchorEl] =
    useState<HTMLButtonElement | null>(null);

  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end", marginBottom: 2 }}>
      {!isEmpty(invoice.attachments) && (
        <InvoiceAttachmentsButton
          variant="text"
          startIcon={<AttachmentIcon />}
          onClick={(e) => setAttachmentAnchorEl(e.currentTarget)}
        >
          {t("common:attachments")}
        </InvoiceAttachmentsButton>
      )}
      <Popover
        open={!!attachmentAnchorEl}
        anchorEl={attachmentAnchorEl}
        onClose={() => setAttachmentAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Box sx={{ padding: 2, width: "550px" }}>
          <InvoiceAttachments
            uploadFile={undefined}
            clearUpload={() => {}}
            invoiceId={invoice.id}
            isDeleteAllowed={false}
            hideTitle
          />
        </Box>
      </Popover>
    </Box>
  );
};
